import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../../../Button';
import Title from '../../../Title';
import Icon from '../../../Icon';
import {getUserDetails} from '../../../../reducers/userDetails';
import { geti18n } from '../../../../reducers/i18n';
import { SmallError } from '../../../InputError';

class DealDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: this.props.summary.get('firstName', this.props.userDetails.get("data").get('firstName', '')),
      lastName: this.props.summary.get('lastName', this.props.userDetails.get("data").get('lastName', '')),
      nationalIdNumber: this.props.summary.get('nationalIdNumber', this.props.userDetails.get("data").get('nationalIdNumber', '')),
      email: this.props.summary.get('email', this.props.userDetails.get("data").get('email', '')),
      privacyPolicy: this.props.summary.get('privacyPolicy', false),
      invalidName: null,
      invalidEmail: null,
      invalidLastName: null,
      invalidNationalIdNumber: null
    };
    this.continue = this.continue.bind(this);
    this.captureInputs = this.captureInputs.bind(this);
    this.selectAllText = this.selectAllText.bind(this);
    this.getValidationError = this.getValidationError.bind(this);
  }

  getValidationError(value, regexFormat, regexEmpty, errorFormat, errorEmpty) {
    if (regexEmpty.test(value)) {
      return <SmallError message={errorEmpty} />;
    }
    else if (!regexFormat.test(value)) {
      return <SmallError message={errorFormat}/>;
    }
    else {
      return null;
    }
  }

  continue(event) {
    event.preventDefault();
    const i18n = this.props.i18n;
    const emailValidation = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;  // eslint-disable-line
    const textValidation = /^(([^\u0000-\u007f]+|\w|-|\s)+)$/;
    const emptyValidation = /^$/;
    const invalidName = this.getValidationError(
      this.state.name, textValidation, emptyValidation,
      i18n('onboarding.formValidation.invalidName'),
      i18n('onboarding.formValidation.invalidEmpty')
    );
    const invalidLastName = this.getValidationError(
      this.state.lastName, textValidation, emptyValidation,
      i18n('onboarding.formValidation.invalidLastName'),
      i18n('onboarding.formValidation.invalidEmpty')
    );
    const invalidEmail = this.getValidationError(
      this.state.email, emailValidation, emptyValidation,
      i18n('onboarding.formValidation.invalidEmail'),
      i18n('onboarding.formValidation.invalidEmpty')
    );
    const invalidNationalIdNumber = this.getValidationError(
      this.state.nationalIdNumber, emptyValidation, emptyValidation,
      i18n('onboarding.formValidation.invalidName'),
      i18n('onboarding.formValidation.invalidEmpty')
    );
    this.setState({
      invalidNationalIdNumber,
      invalidName,
      invalidLastName,
      invalidEmail
    })
    let userData = this.props.userDetails.get("data");
    userData = userData.set('firstName', this.state.name);
    userData = userData.set('lastName', this.state.lastName);
    userData = userData.set('email', this.state.email);
    userData = userData.set('nationalIdNumber', this.state.nationalIdNumber);

    this.props.updateSummary(userData);
    if (this.state.privacyPolicy
      && textValidation.test(this.state.name)
      && textValidation.test(this.state.lastName)
      && emailValidation.test(this.state.email)) {
      this.props.next();
    } else {
      console.log('you need to agree the policy');
    }
  }

  captureInputs(event) {
    const target = event.target;
    const val = event.target.value;

    const name = event.target.name;
    this.setState({
      [name]: val,
      privacyPolicy: target.checked,
      invalidName: null,
      invalidLastName: null,
      invalidEmail: null,
    });
  }

  selectAllText(event) {
    event.target.select();
  }

  render() {
    const i18n = this.props.i18n;
    const errorName = this.state.invalidName;
    const errorLastName = this.state.invalidLastName;
    const errorNationalIdNumber = this.state.invalidNationalIdNumber;
    const errorEmail = this.state.invalidEmail;
    return (
      <div className="user-details text-center">
        <Title text={i18n('onboarding.userDetails.title')} className="form__title" />
        <div className="row justify-content-center">
          <div className="col-9 col-sm-5">
            <form className="form">
              <div className="row">
                <div className="col-sm-6">
                  <input
                    className={`form__input ${this.state.invalidName !== null ? 'form__input--error' : 'form__input mw-100 mb-3'}`}
                    type="text"
                    name="name"
                    onChange={this.captureInputs}
                    onClick={this.selectAllText}
                    value={this.state.name}
                    placeholder={i18n('onboarding.userDetails.firstName')}
                  />{errorName}
                </div>
                <div className="col-sm-6">
                  <input
                    className={`form__input ${this.state.invalidLastName !== null ? 'form__input--error' : 'form__input mw-100 mb-3'}`}
                    type="text"
                    name="lastName"
                    onChange={this.captureInputs}
                    onClick={this.selectAllText}
                    value={this.state.lastName}
                    placeholder={i18n('onboarding.userDetails.lastName')}
                  />{errorLastName}
                </div>
              </div>
              <input
                className="form__input mw-100 mb-3"
                type="number"
                name="nationalIdNumber"
                onChange={this.captureInputs}
                onClick={this.selectAllText}
                value={this.state.nationalIdNumber}
                placeholder={i18n('onboarding.userDetails.nationalId')}
              />{errorNationalIdNumber}
              <input
                className={`form__input ${this.state.invalidEmail !== null ? 'form__input--error' : 'form__input mw-100 mb-4 mb-sm-5'}`}
                type="email"
                name="email"
                onChange={this.captureInputs}
                onClick={this.selectAllText}
                value={this.state.email}
                placeholder={i18n('onboarding.userDetails.email')}
              />{errorEmail}
              <div className="text-initial mb-4 mb-sm-5">
                <input
                  className="form__checkbox"
                  id="privacyPolicy"
                  type="checkbox"
                  name="privacyPolicy"
                  checked={this.state.privacyPolicy}
                  onChange={this.captureInputs}
                  onClick={this.selectAllText}
                />
                <label htmlFor="privacyPolicy" className="form__checkbox--fake">
                  <Icon name="checkmark" />
                </label>
                <label className="form__label mb-0" htmlFor="privacyPolicy">
                  {i18n('onboarding.userDetails.privacyPolicyLinkText1')}{' '}
                  <a className="" href="https://s3-eu-west-1.amazonaws.com/venn-app/Registration+flow+privacy+policy.pdf" target="_blank" rel="noreferrer noopener">
                    {i18n('onboarding.userDetails.privacyPolicyLinkText2')}
                  </a>{' '}
                  {i18n('onboarding.userDetails.privacyPolicyLinkText3')}
                  <a className="" href="https://app-storage.venn.city/%D7%AA%D7%A7%D7%A0%D7%95%D7%9F+%D7%A9%D7%99%D7%A8%D7%95%D7%AA%D7%99%D7%9D.pdf" target="_blank" rel="noreferrer noopener">
                    {i18n('onboarding.userDetails.privacyPolicyLinkText4')}
                  </a>
                </label>
              </div>
              <Button text={i18n('onboarding.userDetails.buttonText')} disabled={!this.state.privacyPolicy} onClick={this.continue} />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userDetails: getUserDetails(state),
  i18n: geti18n(state)
});

export default connect(mapStateToProps)(DealDetails);


// WEBPACK FOOTER //
// ./src/components/Views/Onboarding/Steps/UserDetails.js